module.exports = __webpack_public_path__ + "static/sport/out4.5fbd0a6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Ldp/out4.png
// module id = Nnz/
// module chunks = 0